module.exports = __webpack_public_path__ + "static/media/tech-structured-1.095ffdc1.png";